import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestion = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9708 8.26466C10.751 8.41117 10.5951 8.61188 10.4834 8.83541C10.2981 9.20589 9.84762 9.35606 9.47713 9.17082C9.10665 8.98558 8.95648 8.53507 9.14172 8.16459C9.34246 7.76312 9.65534 7.33883 10.1387 7.01659C10.6268 6.69121 11.2438 6.5 12 6.5C12.6578 6.5 13.369 6.69469 13.9344 7.11875C14.5199 7.55783 14.9375 8.2399 14.9375 9.125C14.9375 10.1584 14.4248 10.8447 13.9108 11.3404C13.7216 11.5229 13.5124 11.6976 13.332 11.8483C13.2804 11.8914 13.2309 11.9328 13.1852 11.9715C13.0026 12.1263 12.86 12.256 12.75 12.38V13.75C12.75 14.1642 12.4143 14.5 12 14.5C11.5858 14.5 11.25 14.1642 11.25 13.75V12.2765C11.25 12.0403 11.3169 11.7726 11.4973 11.5413C11.7162 11.2607 11.9827 11.0245 12.2152 10.8274C12.2788 10.7734 12.3395 10.7227 12.398 10.6738L12.399 10.673C12.5706 10.5295 12.7225 10.4025 12.8695 10.2608C13.2369 9.90641 13.4375 9.58472 13.4375 9.125C13.4375 8.76009 13.2823 8.50467 13.0344 8.31875C12.7665 8.11781 12.384 8 12 8C11.5063 8 11.1858 8.12129 10.9708 8.26466Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12Z",
			fill: "var(--colors-grey-1)"
		})
	]
});
export default SvgQuestion;
